"use client"

import { createContext, ReactNode, useContext, useState } from "react"
import type { SortOptions } from "./sort-products"

type CatalogSortContextValue = {
  sortBy: SortOptions
  setSortBy: (sortBy: SortOptions) => void
}

const CatalogSortContext = createContext<CatalogSortContextValue | null>(null)

export const CatalogSortProvider = ({ children }: { children: ReactNode }) => {
  const [sortBy, setSortBy] = useState<SortOptions>("created_at")

  return (
    <CatalogSortContext.Provider value={{ sortBy, setSortBy }}>
      {children}
    </CatalogSortContext.Provider>
  )
}

export const useCatalogSort = () => {
  const context = useContext(CatalogSortContext)

  if (!context) {
    throw new Error("useCatalogSort must be used within CatalogSortProvider")
  }

  return context
}
